import { Injectable, inject } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { RouterStateSnapshot, TitleStrategy } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'

export const APP_NAME = 'Brief AI'
const SUPPORT_URL_PREFIX = '/app/support'

const isSupportUrl = (url: string): boolean => url.startsWith(SUPPORT_URL_PREFIX)

const withSuffix = (title: string): string => `${title} - ${APP_NAME}`

export function formatPageTitle(title: string): string {
  return withSuffix(title)
}

export function formatSupportPageTitle(translateService: TranslateService, title: string): string {
  return withSuffix(`${translateService.instant('COMMON.SUPPORT_PREFIX')}${title}`)
}

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly titleService = inject(Title)
  private readonly translateService = inject(TranslateService)

  override updateTitle(snapshot: RouterStateSnapshot) {
    const titleKey = this.buildTitle(snapshot)
    if (titleKey === undefined) {
      this.titleService.setTitle(APP_NAME)
      return
    }
    const translatedTitle = this.translateService.instant(titleKey)
    const formatted = isSupportUrl(snapshot.url) ? formatSupportPageTitle(this.translateService, translatedTitle) : formatPageTitle(translatedTitle)
    this.titleService.setTitle(formatted)
  }
}
